<!--推荐主题活动-->
<template>
    <div class="app-container">
        <el-card v-has-btn="'1,2,'" class="mb15">
            <el-row>
                <el-col :span="16" class="mb0">
                    <el-button v-has-btn="'1,2'" @click="handleCreate" type="primary">新增主题活动</el-button>
                </el-col>
            </el-row>
        </el-card>

        <el-card>
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="60px"
                     @submit.native.prevent="handleQuery">
                <el-row class="mt15">
                    <el-col :span="6" class="mb0">
                        <el-form-item label="五馆">
                            <el-select clearable @change="changeMuseum" v-model="queryParams.museumKey" placeholder="请选择">
                                <el-option v-for="item in museumList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="主题" >
                            <el-select clearable @change="pageList(null)" v-model="queryParams.eventItem" placeholder="请选择">
                                <el-option v-for="item in itemList" :key="item.itemId" :label="item.itemMonth+' '+item.itemName"
                                           :value="item.itemId" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="学段">
                            <el-select clearable @change="pageList(null)" v-model="queryParams.periodKey" placeholder="请选择学科">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="5" class="mr0 mb0">
                        <el-form-item label="年级段">
                            <el-select clearable @change="pageList(null)" v-model="queryParams.eventGrade" placeholder="请选择年级段">
                                <el-option v-for="item in eventGradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="mt10">
                    <el-col :span="18" class="mr0 mb0"></el-col>
                    <el-col :span="6" class="mr0 mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.eventTheme" placeholder="请输入主题名称" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQuery" type="primary" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="bre9e mt15">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          :height="`calc(100vh - 370px)`"
                          v-loading="loading" :data="dataList" highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column  label="活动主题" align="center" prop="eventTheme" width="200" >
                        <template #default="scope">
                            <div :title="scope.row.eventTheme" @click="handleView(scope.row)" style="color: #409efe;"
                                 class="text-one cursor">
                                {{ scope.row.eventTheme }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column  label="所属五馆" align="center" prop="museumName">
                        <template #default="scope">
                            <div :title="scope.row.museumName"
                                 class="text-one cursor">
                                {{ scope.row.museumName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column  label="主题" align="center" prop="eventItemName">
                        <template #default="scope">
                            <div :title="scope.row.eventItemName"
                                 class="text-one cursor">
                                {{ scope.row.eventItemName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" label="活动时长" align="center" prop="eventTime">
                    </el-table-column>
                    <el-table-column width="140" label="学段·年级" align="center" prop="">
                        <template #default="scope">
                            <div :title="scope.row.periodName+''+scope.row.gradeName"
                                 class="text-one cursor">
                                {{ scope.row.periodName }}  {{ scope.row.gradeName?'| '+scope.row.gradeName: ''}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" label="年级段" align="center" prop="">
                        <template #default="scope">
                            <div :title="scope.row.eventGradeName"
                                 class="text-one cursor">
                                {{ scope.row.eventGradeName }}
                            </div>
                        </template>
                    </el-table-column>
<!--                    <el-table-column width="140" label="创建时间" align="center" prop="createTime">-->
<!--                        <template #default="scope">-->
<!--                            <div>{{ timestampToTime(scope.row.createTime) }}</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column fixed="right" width="100" align="center" label="操作"
                                     class-name="small-padding fixed-width">
                        <template #default="scope">
                            <el-popover placement="bottom" trigger="click" :width="80" popper-style="padding: 5px 0 0">
                                <template #reference>
                                    <el-button>操作</el-button>
                                </template>
                                <template #default>
                                    <div>
                                        <div class="text-item">
                                            <el-text type="primary" @click="handleView(scope.row)">查看</el-text>
                                        </div>
                                        <div class="text-item">
                                            <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                        </div>
                                        <div class="text-item">
                                            <el-popconfirm
                                              confirm-button-text="是"
                                              cancel-button-text="否"
                                              :icon="InfoFilled"
                                              icon-color="#626AEF"
                                              title="确定删除?"
                                              @confirm="handleDelete(scope.row)">
                                                <template #reference>
                                                    <el-text type="danger">删除</el-text>
                                                </template>
                                            </el-popconfirm>
                                        </div>

                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]" :total="total"
                            :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="pageList" />
            </div>
        </el-card>


    </div>
</template>
<script>
import { queryDict } from "@/api/admin/public";
import {pageEvent,deleteEvent} from "@/api/admin/event"
import {timestampDate, timestampToTime} from "@/utils/date";
import {listItem, listItemByMuseum} from "@/api/admin/item";
export default {
    name: "eventIndex",
    components: {},
    data() {
        return {
            timestampToTime,
            timestampDate,
            loading: false,
            periodList:[],
            gradeList:[],
            itemList:[],
            museumList:[],
            typeList: [
                { name: '音乐', value: 1 },
                { name: '美术', value: 2 },
                { name: '主题班会', value: 3 },
            ],
            dataList:[],
            eventGradeList:[],
            total:0,
            queryParams:{
                eventTheme:'',
                eventItem:'',
                periodKey:'',
                museumKey:'',
                gradeKey:'',
                eventGrade:'',
                pageNum: 1,
                pageSize: 10,
            }
        };
    },
    created() {
        this.getQueryDict();
        // this.queryItemList();
        this.pageList();
    },
    activated() {},
    watch: {},
    methods: {
        queryItemList(){
            listItem({ itemType: 2 }).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.gradeList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.pageList(null)
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'grade_period' }).then(res => {
                this.eventGradeList = res.data.data;
            })
            queryDict({ code: 'museum_info' }).then(res => {
                if (res.data.code === 1) {
                    this.museumList = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        changeMuseum(){
            this.itemList = [];
            this.queryParams.eventItem = '';
            if (!this.queryParams.museumKey){
                this.pageList(null)
                return;
            }
            listItemByMuseum({ museumKey: this.queryParams.museumKey }).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
            this.pageList(null)
        },
        handleCreate(){
            this.$router.push({
                path: "/eventCreate",
            });
        },
        handleUpdate(row){
            this.$router.push({
                path: "/eventCreate",
                query: {
                    eventId: row.eventId,
                }
            });
        },
        handleDelete(row){
            deleteEvent({ eventId: row.eventId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.pageList(null);
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleQuery(){
            this.pageList(null);
        },
        pageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageEvent(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
        handleView(row){
            this.$router.push({
                path: "/eventDetail",
                query: {
                    eventId: row.eventId,
                }
            });
        }
    }
}
</script>

<style scoped>
/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}
</style>